import React from "react";
import { IUserData } from "@/types";

interface Props {
    badge?: "founder" | "admin" | "staff" | "pro";
    user?: IUserData;
    colour?: string;
}

const ProfileBadges: React.FC<Props> = ({ badge, user, colour }) => {
    const svgs = {
        founder: (
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 1000 1000"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xmlSpace="preserve"
                style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: 2,
                }}
            >
                <rect
                    id="siteFounder"
                    x="0"
                    y="0"
                    width="1000"
                    height="1000"
                    style={{ fill: "none" }}
                />
                <clipPath id="_clip1">
                    <rect x="0" y="0" width="1000" height="1000" />
                </clipPath>
                <g clipPath="url(#_clip1)">
                    <path
                        d="M478.071,163.079c4.39,-7.975 12.801,-12.945 21.904,-12.945c9.103,-0 17.514,4.97 21.904,12.945l147.63,280.256c8.734,16.1 25.642,26.162 43.958,26.162c11.626,0 22.895,-4.053 31.857,-11.459l213.893,-183.237c4.458,-3.626 10.032,-5.606 15.778,-5.606c13.717,-0 25.005,11.287 25.005,25.005c-0,2.214 -0.294,4.419 -0.875,6.556l-141.728,512.403c-5.927,21.48 -25.528,36.529 -47.81,36.707l-619.174,0c-22.3,-0.155 -41.928,-15.21 -47.86,-36.707l-141.678,-512.353c-0.581,-2.137 -0.875,-4.342 -0.875,-6.556c-0,-13.718 11.288,-25.005 25.005,-25.005c5.746,-0 11.32,1.98 15.778,5.606l213.843,183.237c8.962,7.406 20.231,11.459 31.857,11.459c18.316,0 35.224,-10.062 43.958,-26.162l147.63,-280.306Z"
                        style={{
                            fill: colour || "#fff",
                            fillRule: "nonzero",
                        }}
                    />
                </g>
            </svg>
        ),
        admin: (
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 1000 1000"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
                style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: 2,
                }}
            >
                <rect
                    id="siteAdmin"
                    x="0"
                    y="0"
                    width="1000"
                    height="1000"
                    style={{ fill: "none" }}
                />
                <path
                    d="M779.863,534.919c0,174.915 -122.44,262.372 -267.969,313.097c-7.619,2.582 -15.9,2.458 -23.438,-0.35c-145.879,-50.375 -268.319,-137.832 -268.319,-312.747l-0,-244.88c-0,-19.191 15.792,-34.983 34.983,-34.983c69.965,-0 157.423,-41.98 218.293,-95.154c15.245,-13.025 37.929,-13.025 53.174,0c61.22,53.524 148.328,95.154 218.293,95.154c19.191,-0 34.983,15.792 34.983,34.983l0,244.88Z"
                    style={{
                        fill: colour || "#fff",
                        fillRule: "nonzero",
                    }}
                />
            </svg>
        ),
        staff: (
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 1000 1000"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
                style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: 2,
                }}
            >
                <rect
                    id="siteStaff"
                    x="0"
                    y="0"
                    width="1000"
                    height="1000"
                    style={{ fill: "none" }}
                />
                <clipPath id="_clip1">
                    <rect
                        x="220.147"
                        y="150.16"
                        width="281.335"
                        height="699.706"
                    />
                </clipPath>
                <g clipPath="url(#_clip1)">
                    <path
                        d="M779.853,534.931c-0,174.908 -122.436,262.362 -267.959,313.085c-7.619,2.582 -15.9,2.458 -23.438,-0.35c-145.873,-50.373 -268.309,-137.827 -268.309,-312.735l0,-244.871c0,-19.19 15.792,-34.982 34.982,-34.982c69.963,0 157.417,-41.977 218.285,-95.149c15.245,-13.025 37.927,-13.025 53.172,-0c61.218,53.521 148.322,95.149 218.285,95.149c19.19,0 34.982,15.792 34.982,34.982l-0,244.871Z"
                        style={{
                            fill: colour || "#fff",
                            fillRule: "nonzero",
                        }}
                    />
                </g>
                <path
                    d="M779.853,534.931c-0,174.908 -122.436,262.362 -267.959,313.085c-7.619,2.582 -15.9,2.458 -23.438,-0.35c-145.873,-50.373 -268.309,-137.827 -268.309,-312.735l0,-244.871c0,-19.19 15.792,-34.982 34.982,-34.982c69.963,0 157.417,-41.977 218.285,-95.149c15.245,-13.025 37.927,-13.025 53.172,-0c61.218,53.521 148.322,95.149 218.285,95.149c19.19,0 34.982,15.792 34.982,34.982l-0,244.871Zm-489.742,-212.412l-0,212.412c-0,136.323 97.669,202.043 210.491,242.828c112.175,-41.09 209.287,-106.863 209.287,-242.828l0,-212.394c-69.888,-9.608 -148.595,-45.975 -209.926,-93.87c-61.412,47.777 -140.116,84.204 -209.852,93.852Z"
                    style={{
                        fill: colour || "#fff",
                        fillRule: "nonzero",
                    }}
                />
            </svg>
        ),
        pro: (
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 1000 1000"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
                style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: 2,
                }}
            >
                <rect
                    id="siteVerified"
                    x="0"
                    y="0"
                    width="1000"
                    height="1000"
                    style={{ fill: "none" }}
                />
                <path
                    d="M215.107,381.616c-2.211,-9.959 -3.326,-20.13 -3.326,-30.332c-0,-76.776 63.177,-139.953 139.953,-139.953c10.299,0 20.567,1.137 30.617,3.39c25.692,-40.181 70.217,-64.561 117.911,-64.561c47.693,0 92.218,24.38 117.91,64.561c10.076,-2.265 20.372,-3.408 30.7,-3.408c76.776,-0 139.953,63.177 139.953,139.953c0,10.328 -1.143,20.623 -3.408,30.699c40.181,25.693 64.561,70.218 64.561,117.911c-0,47.693 -24.38,92.219 -64.561,117.911c2.253,10.05 3.39,20.318 3.39,30.617c-0,76.776 -63.178,139.953 -139.954,139.953c-10.201,0 -20.372,-1.115 -30.331,-3.326c-25.66,40.338 -70.277,64.835 -118.085,64.835c-47.809,0 -92.426,-24.497 -118.086,-64.835c-10.05,2.253 -20.318,3.39 -30.617,3.39c-76.776,0 -139.953,-63.177 -139.953,-139.953c-0,-10.202 1.115,-20.372 3.326,-30.331c-40.496,-25.628 -65.111,-70.337 -65.111,-118.261c-0,-47.924 24.615,-92.632 65.111,-118.26Zm37.421,59.13c-20.248,12.814 -32.555,35.168 -32.555,59.13c-0,23.962 12.307,46.316 32.555,59.13c24.93,15.777 37.286,45.495 30.892,74.296c-1.105,4.98 -1.663,10.065 -1.663,15.166c0,38.388 31.589,69.976 69.977,69.976c5.15,0 10.284,-0.568 15.308,-1.695c28.782,-6.452 58.52,5.835 74.352,30.723c12.83,20.169 35.139,32.418 59.043,32.418c23.904,-0 46.212,-12.249 59.042,-32.418c15.803,-24.842 45.466,-37.135 74.209,-30.755c4.979,1.106 10.065,1.664 15.165,1.664c38.388,-0 69.977,-31.589 69.977,-69.977c0,-5.15 -0.568,-10.284 -1.695,-15.309c-6.44,-28.723 5.785,-58.406 30.585,-74.264c20.091,-12.846 32.281,-35.108 32.281,-58.955c-0,-23.847 -12.19,-46.109 -32.281,-58.955c-24.813,-15.866 -37.036,-45.57 -30.576,-74.305c1.133,-5.038 1.705,-10.186 1.705,-15.35c-0,-38.388 -31.589,-69.977 -69.977,-69.977c-5.164,0 -10.312,0.572 -15.35,1.705c-28.735,6.46 -58.439,-5.763 -74.305,-30.577c-12.846,-20.09 -35.109,-32.28 -58.955,-32.28c-23.847,-0 -46.109,12.19 -58.956,32.28c-15.857,24.801 -45.54,37.026 -74.264,30.586c-5.024,-1.127 -10.158,-1.695 -15.308,-1.695c-38.388,-0 -69.977,31.588 -69.977,69.976c0,5.101 0.558,10.187 1.663,15.166c6.394,28.801 -5.962,58.519 -30.892,74.296Z"
                    style={{
                        fill: colour || "#fff",
                    }}
                />
                <path
                    d="M395.297,499.876l69.976,69.977l139.954,-139.954"
                    style={{
                        fill: "none",
                        fillRule: "nonzero",
                        stroke: colour || "#fff",
                        strokeWidth: "69.98px",
                    }}
                />
            </svg>
        ),
    };
    if (badge) {
        return <div className="size-8">{svgs[badge]}</div>;
    }
    if (user) {
        return (
            <>
                {(user.username == "trent" || user.username == "tommerty") && (
                    <div className="size-6">{svgs["founder"]}</div>
                )}
                {(user.account_type === "premium" ||
                    user.account_type === "bplus" ||
                    user.account_type === "bpro") && (
                    <div className="size-6">{svgs["pro"]}</div>
                )}
                {user.access === "staff" && (
                    <div className="size-6">{svgs["staff"]}</div>
                )}
                {user.access === "admin" && (
                    <div className="size-6">{svgs["admin"]}</div>
                )}
            </>
        );
    }
};

export default ProfileBadges;
